import React, { useState, useCallback } from 'react';

const C = {
 accent:'#3AAF58', accentLight:'#EAF7EE', accentDark:'#2E8B47',
 bg:'#0A1628', surface:'#0F2040',
 border:'rgba(30,58,95,.8)', border2:'rgba(30,58,95,1)',
 text:'#F0F2FF', text2:'#A0A8C0', text3:'#606880',
 amber:'#D4840F', amberBg:'rgba(245,158,11,.1)', amberBorder:'#F0D499',
 red:'#EF4444', redBg:'rgba(239,68,68,.1)', redBorder:'#F0B8B8',
 blue:'#FFFFFF', blueBg:'#EAF1FB',
 purple:'#6B48A8', purpleBg:'#F0EBFB',
 teal:'#1A7A7A', tealBg:'#E7F5F5',
 dark:'#0F1E14', dark2:'#1A3A22',
};
const inr = n => '₹'+Number(Math.round(n)||0).toLocaleString('en-IN');

// ── ROOMS DATA ────────────────────────────────────────────────────────────────
const ROOMS = [
 {id:'R101',no:101,type:'Forest View Room', floor:1,view:'Forest', capacity:2,baseRate:5500, color:C.accent, bg:C.accentLight},
 {id:'R102',no:102,type:'Forest View Room', floor:1,view:'Forest', capacity:2,baseRate:5500, color:C.accent, bg:C.accentLight},
 {id:'R103',no:103,type:'Forest View Room', floor:1,view:'Forest', capacity:2,baseRate:5500, color:C.accent, bg:C.accentLight},
 {id:'R104',no:104,type:'Forest View Room', floor:1,view:'Forest', capacity:2,baseRate:5500, color:C.accent, bg:C.accentLight},
 {id:'R201',no:201,type:'Lakeside Suite', floor:2,view:'Lake', capacity:3,baseRate:9500, color:C.blue, bg:C.blueBg},
 {id:'R202',no:202,type:'Lakeside Suite', floor:2,view:'Lake', capacity:3,baseRate:9500, color:C.blue, bg:C.blueBg},
 {id:'R203',no:203,type:'Lakeside Suite', floor:2,view:'Lake', capacity:3,baseRate:9500, color:C.blue, bg:C.blueBg},
 {id:'R301',no:301,type:'Canopy Cottage', floor:3,view:'Garden', capacity:4,baseRate:14500,color:C.purple, bg:C.purpleBg},
 {id:'R302',no:302,type:'Canopy Cottage', floor:3,view:'Garden', capacity:4,baseRate:14500,color:C.purple, bg:C.purpleBg},
 {id:'R303',no:303,type:'Canopy Cottage', floor:3,view:'Garden', capacity:4,baseRate:14500,color:C.purple, bg:C.purpleBg},
 {id:'T001',no:'T1',type:'Jungle Tent', floor:0,view:'Jungle', capacity:2,baseRate:3500, color:C.amber, bg:C.amberBg},
 {id:'T002',no:'T2',type:'Jungle Tent', floor:0,view:'Jungle', capacity:2,baseRate:3500, color:C.amber, bg:C.amberBg},
];

const ROOM_STATUS = {
 free: {label:'Available', color:C.accent, bg:C.accentLight, border:C.accent},
 occupied: {label:'Occupied', color:C.blue, bg:C.blueBg, border:C.blue},
 checkin: {label:'Check-in', color:C.purple, bg:C.purpleBg, border:C.purple},
 checkout: {label:'Check-out', color:C.amber, bg:C.amberBg, border:C.amber},
 dirty: {label:'Dirty', color:C.red, bg:C.redBg, border:C.red},
 blocked: {label:'Blocked', color:C.text3, bg:'#F0F0F0', border:C.text3},
 maintenance:{label:'Maint.', color:C.orange||'#E05A00',bg:'#FEF0E6',border:'#E05A00'},
};

// ── HELPERS ───────────────────────────────────────────────────────────────────
const today = new Date();
const addDays = (d,n) => { const x=new Date(d); x.setDate(x.getDate()+n); return x; };
const fmt = d => d.toISOString().slice(0,10);
const fmtDisplay = d => new Date(d).toLocaleDateString('en-IN',{day:'2-digit',month:'short'});
const BOOKINGS = [];
const getBookingsForRoom = (roomId) => BOOKINGS.filter(b=>b.roomId===roomId);

const getStatusForDate = (roomId, dateStr) => {
 const booking = BOOKINGS.find(b=>{
 if(b.roomId!==roomId) return false;
 const ci=new Date(b.checkIn), co=new Date(b.checkOut), d=new Date(dateStr);
 return d>=ci && d<co;
 });
 if(!booking) return 'free';
 return booking.status||'occupied';
};

const getBookingForDate = (roomId, dateStr) =>
 BOOKINGS.find(b=>{
 if(b.roomId!==roomId) return false;
 const ci=new Date(b.checkIn), co=new Date(b.checkOut), d=new Date(dateStr);
 return d>=ci && d<co;
 });


// ── ROOM DETAIL POPUP ─────────────────────────────────────────────────────────
function RoomPopup({room, booking, date, onClose}) {
 const st = booking ? ROOM_STATUS[booking.status]||ROOM_STATUS.occupied : ROOM_STATUS.free;
 return (
 <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.5)',zIndex:300,display:'flex',alignItems:'center',justifyContent:'center',padding:20}} onClick={onClose}>
 <div style={{background:C.surface,borderRadius:20,width:380,boxShadow:'0 24px 64px rgba(0,0,0,.2)',overflow:'hidden'}} onClick={e=>e.stopPropagation()}>
 {/* Header */}
 <div style={{background:`linear-gradient(135deg,${room.color},${room.color}CC)`,padding:'20px 24px'}}>
 <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start'}}>
 <div>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:22,fontWeight:800,color:'#fff'}}>Room {room.no}</div>
 <div style={{fontSize:13,color:'rgba(255,255,255,.7)',marginTop:2}}>{room.type}</div>
 </div>
 <button onClick={onClose} style={{width:30,height:30,borderRadius:8,border:'1px solid rgba(255,255,255,.3)',background:'rgba(255,255,255,.1)',color:'#fff',cursor:'pointer',fontSize:14}}></button>
 </div>
 <div style={{display:'flex',gap:8,marginTop:12,flexWrap:'wrap'}}>
 <span style={{padding:'4px 12px',borderRadius:99,background:'rgba(255,255,255,.2)',color:'#fff',fontSize:11,fontWeight:600}}>Floor {room.floor||'G'}</span>
 <span style={{padding:'4px 12px',borderRadius:99,background:'rgba(255,255,255,.2)',color:'#fff',fontSize:11,fontWeight:600}}>{room.view} View</span>
 <span style={{padding:'4px 12px',borderRadius:99,background:'rgba(255,255,255,.2)',color:'#fff',fontSize:11,fontWeight:600}}> {room.capacity} Guests</span>
 <span style={{padding:'4px 12px',borderRadius:99,background:'rgba(255,255,255,.2)',color:'#fff',fontSize:11,fontWeight:600}}>{inr(room.baseRate)}/night</span>
 </div>
 </div>

 <div style={{padding:'20px 24px'}}>
 {/* Status */}
 <div style={{padding:'12px 16px',background:st.bg,borderRadius:12,border:`1.5px solid ${st.border}`,marginBottom:16,display:'flex',justifyContent:'space-between',alignItems:'center'}}>
 <div>
 <div style={{fontSize:11,color:C.text3,marginBottom:2}}>Status for {fmtDisplay(date)}</div>
 <div style={{fontSize:16,fontWeight:700,color:st.color}}>{st.label}</div>
 </div>
 <div style={{fontSize:28}}>{st.label==='Available'?'':st.label==='Occupied'?'':st.label==='Check-in'?'':st.label==='Check-out'?'':st.label==='Dirty'?'':''}</div>
 </div>

 {/* Booking details */}
 {booking ? (
 <div style={{marginBottom:16}}>
 <div style={{fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',letterSpacing:'.06em',marginBottom:10}}>Current Booking</div>
 {[
 ['Booking ID',booking.id],
 ['Guest / Company',booking.guest],
 ['Check-in',fmtDisplay(booking.checkIn)],
 ['Check-out',fmtDisplay(booking.checkOut)],
 ['Guests',booking.pax+' persons'],
 ['Amount',inr(booking.amount)],
 ['Source',booking.source],
 ].map(([k,v])=>(
 <div key={k} style={{display:'flex',justifyContent:'space-between',padding:'7px 0',borderBottom:`1px solid ${C.border}`}}>
 <span style={{fontSize:12,color:C.text3}}>{k}</span>
 <span style={{fontSize:12,fontWeight:600,color:C.text}}>{v}</span>
 </div>
 ))}
 </div>
 ) : (
 <div style={{padding:'16px',background:C.accentLight,borderRadius:12,border:`1px solid ${C.accent}44`,marginBottom:16,textAlign:'center'}}>
 <div style={{fontSize:20,marginBottom:6}}></div>
 <div style={{fontWeight:700,fontSize:14,color:C.accent}}>Room Available</div>
 <div style={{fontSize:11,color:C.text3,marginTop:2}}>{fmtDisplay(date)} · {inr(room.baseRate)}/night</div>
 </div>
 )}

 {/* Upcoming for this room */}
 <div>
 <div style={{fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',letterSpacing:'.06em',marginBottom:8}}>Upcoming Bookings</div>
 {getBookingsForRoom(room.id).filter(b=>new Date(b.checkIn)>=today).length===0
 ? <div style={{fontSize:12,color:C.text3,textAlign:'center',padding:'12px'}}>No upcoming bookings</div>
 : getBookingsForRoom(room.id).filter(b=>new Date(b.checkIn)>=today).map(b=>(
 <div key={b.id} style={{padding:'8px 12px',background:C.bg,borderRadius:9,border:`1px solid ${C.border}`,marginBottom:6}}>
 <div style={{display:'flex',justifyContent:'space-between',marginBottom:2}}>
 <span style={{fontSize:12,fontWeight:600,color:C.text}}>{b.guest}</span>
 <span style={{fontSize:11,color:C.accent,fontWeight:600}}>{inr(b.amount)}</span>
 </div>
 <div style={{fontSize:11,color:C.text3}}>{fmtDisplay(b.checkIn)} → {fmtDisplay(b.checkOut)} · {b.pax} pax</div>
 </div>
 ))
 }
 </div>
 </div>
 </div>
 </div>
 );
}

// ── WEEKLY CALENDAR ───────────────────────────────────────────────────────────
function WeeklyCalendar({startDate, onCellClick}) {
 const days = Array.from({length:7},(_,i)=>fmt(addDays(startDate,i)));
 const dayNames = days.map(d=>new Date(d).toLocaleDateString('en-IN',{weekday:'short',day:'numeric',month:'short'}));

 return (
 <div style={{overflowX:'auto'}}>
 <table style={{width:'100%',borderCollapse:'collapse',minWidth:900}}>
 <thead>
 <tr>
 <th style={{width:200,padding:'10px 14px',textAlign:'left',background:`linear-gradient(135deg,${C.dark2},#243828)`,color:'#fff',fontSize:12,fontWeight:700,borderRadius:'8px 0 0 0',position:'sticky',left:0,zIndex:10}}>
 Room Details
 </th>
 {days.map((d,i)=>{
 const isToday = d===fmt(today);
 return (
 <th key={d} style={{padding:'10px 8px',textAlign:'center',background:isToday?C.accent:`linear-gradient(135deg,${C.dark2},#243828)`,color:'#fff',fontSize:11,fontWeight:isToday?800:600,minWidth:110,border:'1px solid rgba(255,255,255,.1)'}}>
 {dayNames[i]}
 {isToday&&<div style={{fontSize:9,marginTop:2,opacity:.8}}>TODAY</div>}
 </th>
 );
 })}
 </tr>
 </thead>
 <tbody>
 {/* Group by type */}
 {['Forest View Room','Lakeside Suite','Canopy Cottage','Jungle Tent'].map(type=>{
 const typeRooms = ROOMS.filter(r=>r.type===type);
 if(typeRooms.length===0) return null;
 return [
 <tr key={`header-${type}`}>
 <td colSpan={8} style={{padding:'8px 14px',background:typeRooms[0].bg,borderBottom:`2px solid ${typeRooms[0].color}`,fontSize:11,fontWeight:700,color:typeRooms[0].color,textTransform:'uppercase',letterSpacing:'.06em',position:'sticky',left:0}}>
 {typeRooms[0].type} — {typeRooms.length} rooms · {inr(typeRooms[0].baseRate)}/night
 </td>
 </tr>,
 ...typeRooms.map(room=>(
 <tr key={room.id} style={{borderBottom:`1px solid ${C.border}`}}>
 {/* Room info cell */}
 <td style={{padding:'10px 14px',background:C.surface,position:'sticky',left:0,zIndex:5,borderRight:`2px solid ${C.border}`,minWidth:200}}>
 <div style={{display:'flex',alignItems:'center',gap:8}}>
 <div style={{width:36,height:36,borderRadius:10,background:room.bg,border:`1.5px solid ${room.color}`,display:'flex',alignItems:'center',justifyContent:'center',fontSize:16,flexShrink:0}}>
 {room.type.includes('Suite')?'':room.type.includes('Cottage')?'':room.type.includes('Tent')?'':''}
 </div>
 <div>
 <div style={{fontWeight:700,fontSize:13,color:C.text}}>Room {room.no}</div>
 <div style={{fontSize:10,color:C.text3}}>{room.view} View · {room.capacity} guests</div>
 </div>
 </div>
 </td>
 {/* Date cells */}
 {days.map(d=>{
 const status = getStatusForDate(room.id,d);
 const booking = getBookingForDate(room.id,d);
 const st = ROOM_STATUS[status]||ROOM_STATUS.free;
 const isCheckIn = booking && booking.checkIn===d;
 const isCheckOut = booking && booking.checkOut===fmt(addDays(new Date(d),1));
 const isToday = d===fmt(today);
 return (
 <td key={d} onClick={()=>onCellClick(room,booking,d)}
 style={{padding:'4px',background:isToday?'#F8FFF8':C.surface,border:`1px solid ${C.border}`,cursor:'pointer',position:'relative',minWidth:110,height:52}}>
 <div style={{
 height:'100%',borderRadius:8,background:st.bg,border:`1.5px solid ${st.border}`,
 display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',padding:'4px 6px',
 position:'relative',overflow:'hidden',minHeight:44,
 }}>
 {/* Check-in indicator */}
 {isCheckIn&&<div style={{position:'absolute',left:0,top:0,bottom:0,width:3,background:st.color,borderRadius:'4px 0 0 4px'}}/>}
 <div style={{fontSize:11,fontWeight:700,color:st.color,textAlign:'center',lineHeight:1.2}}>
 {status==='free'?' Free':booking?.guest?.split(' ')[0]||st.label}
 </div>
 {booking&&<div style={{fontSize:9,color:st.color,opacity:.7,textAlign:'center',lineHeight:1.2,marginTop:2}}>
 {isCheckIn?'Check-in':isCheckOut?'Check-out':booking.pax+'pax'}
 </div>}
 </div>
 </td>
 );
 })}
 </tr>
 ))
 ];
 })}
 </tbody>
 </table>
 </div>
 );
}

// ── MONTHLY CALENDAR ──────────────────────────────────────────────────────────
function MonthlyCalendar({year, month, onCellClick}) {
 const firstDay = new Date(year,month,1);
 const lastDay = new Date(year,month+1,0);
 const days = Array.from({length:lastDay.getDate()},(_,i)=>fmt(new Date(year,month,i+1)));

 return (
 <div style={{overflowX:'auto'}}>
 <table style={{width:'100%',borderCollapse:'collapse',minWidth:Math.max(900,days.length*36+220)}}>
 <thead>
 <tr>
 <th style={{width:200,padding:'10px 14px',textAlign:'left',background:`linear-gradient(135deg,${C.dark2},#243828)`,color:'#fff',fontSize:12,fontWeight:700,position:'sticky',left:0,zIndex:10}}>
 Room
 </th>
 {days.map(d=>{
 const isToday = d===fmt(today);
 const dayNum = new Date(d).getDate();
 const dayName = new Date(d).toLocaleDateString('en-IN',{weekday:'short'});
 return (
 <th key={d} style={{padding:'6px 4px',textAlign:'center',background:isToday?C.accent:`linear-gradient(135deg,${C.dark2},#243828)`,color:'#fff',fontSize:10,fontWeight:isToday?800:500,minWidth:36,border:'1px solid rgba(255,255,255,.1)'}}>
 <div style={{fontWeight:800}}>{dayNum}</div>
 <div style={{opacity:.6,fontSize:8}}>{dayName}</div>
 </th>
 );
 })}
 </tr>
 </thead>
 <tbody>
 {ROOMS.map(room=>(
 <tr key={room.id} style={{borderBottom:`1px solid ${C.border}`}}>
 <td style={{padding:'8px 14px',background:C.surface,position:'sticky',left:0,zIndex:5,borderRight:`2px solid ${C.border}`}}>
 <div style={{display:'flex',alignItems:'center',gap:8}}>
 <div style={{width:10,height:10,borderRadius:3,background:room.color,flexShrink:0}}/>
 <div>
 <div style={{fontWeight:700,fontSize:12,color:C.text}}>Room {room.no}</div>
 <div style={{fontSize:9,color:C.text3}}>{room.type.split(' ').slice(0,2).join(' ')} · {room.view}</div>
 </div>
 </div>
 </td>
 {days.map(d=>{
 const status = getStatusForDate(room.id,d);
 const booking = getBookingForDate(room.id,d);
 const st = ROOM_STATUS[status]||ROOM_STATUS.free;
 const isToday = d===fmt(today);
 const isCheckIn = booking&&booking.checkIn===d;
 return (
 <td key={d} onClick={()=>onCellClick(room,booking,d)}
 style={{padding:2,background:isToday?'#F8FFF8':C.surface,border:`1px solid ${C.border}`,cursor:'pointer'}}>
 <div style={{height:28,borderRadius:5,background:st.bg,border:`1px solid ${st.border}33`,display:'flex',alignItems:'center',justifyContent:'center',position:'relative'}}>
 {isCheckIn&&<div style={{position:'absolute',left:0,top:0,bottom:0,width:2,background:st.color,borderRadius:'3px 0 0 3px'}}/>}
 <div style={{fontSize:8,fontWeight:700,color:st.color,textAlign:'center',lineHeight:1}}>
 {status==='free'?'':status==='maintenance'?'M':booking?.guest?.charAt(0)||''}
 </div>
 </div>
 </td>
 );
 })}
 </tr>
 ))}
 </tbody>
 </table>
 </div>
 );
}


// ── MAIN ROOM CALENDAR ────────────────────────────────────────────────────────
export default function RoomCalendar() {
 const [view, setView] = useState('weekly');
 const [weekStart, setWeekStart] = useState(today);
 const [calMonth, setCalMonth] = useState(today.getMonth());
 const [calYear, setCalYear] = useState(today.getFullYear());
 const [popup, setPopup] = useState(null); // {room, booking, date}
 const [filterType, setFilterType] = useState('All');

 const prevWeek = () => setWeekStart(p=>addDays(p,-7));
 const nextWeek = () => setWeekStart(p=>addDays(p,7));
 const prevMonth = () => { if(calMonth===0){setCalMonth(11);setCalYear(p=>p-1);}else setCalMonth(p=>p-1); };
 const nextMonth = () => { if(calMonth===11){setCalMonth(0);setCalYear(p=>p+1);}else setCalMonth(p=>p+1); };

 const onCellClick = (room,booking,date) => setPopup({room,booking,date});

 // Stats
 const todayBookings = BOOKINGS.filter(b=>{
 const ci=new Date(b.checkIn),co=new Date(b.checkOut),t=new Date(fmt(today));
 return t>=ci&&t<co;
 });
 const occupiedToday = todayBookings.length;
 const availableToday = ROOMS.length - occupiedToday;
 const todayRevenue = todayBookings.reduce((s,b)=>s+b.amount,0);
 const checkinsToday = BOOKINGS.filter(b=>b.checkIn===fmt(today)).length;
 const checkoutsToday = BOOKINGS.filter(b=>{
 const co = addDays(new Date(b.checkOut),-1);
 return fmt(co)===fmt(today);
 }).length;

 const MONTH_NAMES = ['January','February','March','April','May','June','July','August','September','October','November','December'];

 return (
 <div style={{fontFamily:'Inter,sans-serif',color:C.text,background:C.bg,minHeight:'100vh'}}>

 {popup&&<RoomPopup room={popup.room} booking={popup.booking} date={popup.date} onClose={()=>setPopup(null)}/>}

 {/* ── HEADER ── */}
 <div style={{background:`linear-gradient(135deg,${C.dark},${C.dark2})`,padding:'24px 28px',position:'sticky',top:0,zIndex:50}}>
 <div style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',marginBottom:20}}>
 <div>
 <div style={{fontSize:10,color:'rgba(255,255,255,.3)',textTransform:'uppercase',letterSpacing:'.14em',marginBottom:6}}> Rooms & PMS</div>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:26,fontWeight:800,color:'#fff',letterSpacing:'-.02em'}}>Room Availability Calendar</div>
 <div style={{fontSize:12,color:'rgba(255,255,255,.4)',marginTop:2}}>Click any cell to view room details and booking info</div>
 </div>
 {/* View toggle */}
 <div style={{display:'flex',gap:6,background:'rgba(255,255,255,.08)',borderRadius:12,padding:4}}>
 {[['weekly',' Weekly'],['monthly',' Monthly']].map(([v,l])=>(
 <button key={v} onClick={()=>setView(v)}
 style={{padding:'8px 18px',borderRadius:9,border:'none',background:view===v?C.accent:'transparent',color:view===v?'#fff':'rgba(255,255,255,.5)',fontSize:12,fontWeight:600,cursor:'pointer',transition:'all .2s'}}>
 {l}
 </button>
 ))}
 </div>
 </div>

 {/* KPI row */}
 <div style={{display:'grid',gridTemplateColumns:'repeat(6,1fr)',gap:10,marginBottom:16}}>
 {[
 {l:'Total Rooms', v:ROOMS.length, ic:'',c:'rgba(255,255,255,.9)'},
 {l:'Occupied Today', v:occupiedToday, ic:'',c:'#64B5F6'},
 {l:'Available Today',v:availableToday, ic:'',c:'#81C784'},
 {l:'Check-ins Today',v:checkinsToday, ic:'',c:'#CE93D8'},
 {l:'Check-outs Today',v:checkoutsToday, ic:'',c:'#FFB347'},
 {l:'Occupancy %', v:Math.round(occupiedToday/ROOMS.length*100)+'%',ic:'',c:C.accent},
 ].map(k=>(
 <div key={k.l} style={{padding:'12px 14px',background:'rgba(255,255,255,.07)',borderRadius:12,border:'1px solid rgba(255,255,255,.08)',textAlign:'center'}}>
 <div style={{fontSize:18,marginBottom:4}}>{k.ic}</div>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:22,fontWeight:800,color:k.c,letterSpacing:'-.02em'}}>{k.v}</div>
 <div style={{fontSize:9,color:'rgba(255,255,255,.3)',textTransform:'uppercase',letterSpacing:'.05em',marginTop:2}}>{k.l}</div>
 </div>
 ))}
 </div>

 {/* Navigation & Legend */}
 <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',flexWrap:'wrap',gap:10}}>
 {/* Date navigation */}
 <div style={{display:'flex',alignItems:'center',gap:10}}>
 <button onClick={view==='weekly'?prevWeek:prevMonth}
 style={{width:34,height:34,borderRadius:9,border:'1px solid rgba(255,255,255,.2)',background:'rgba(255,255,255,.08)',color:'#fff',cursor:'pointer',fontSize:16}}>←</button>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:15,fontWeight:700,color:'#fff',minWidth:180,textAlign:'center'}}>
 {view==='weekly'
 ? `${fmtDisplay(fmt(weekStart))} — ${fmtDisplay(fmt(addDays(weekStart,6)))}`
 : `${MONTH_NAMES[calMonth]} ${calYear}`
 }
 </div>
 <button onClick={view==='weekly'?nextWeek:nextMonth}
 style={{width:34,height:34,borderRadius:9,border:'1px solid rgba(255,255,255,.2)',background:'rgba(255,255,255,.08)',color:'#fff',cursor:'pointer',fontSize:16}}>→</button>
 <button onClick={()=>{setWeekStart(today);setCalMonth(today.getMonth());setCalYear(today.getFullYear());}}
 style={{padding:'6px 14px',borderRadius:9,border:`1px solid ${C.accent}`,background:C.accent+'22',color:C.accent,fontSize:11,fontWeight:600,cursor:'pointer'}}>Today</button>
 </div>

 {/* Legend */}
 <div style={{display:'flex',gap:10,flexWrap:'wrap'}}>
 {Object.entries(ROOM_STATUS).map(([key,st])=>(
 <div key={key} style={{display:'flex',alignItems:'center',gap:5}}>
 <div style={{width:12,height:12,borderRadius:3,background:st.bg,border:`1.5px solid ${st.border}`}}/>
 <span style={{fontSize:10,color:'rgba(255,255,255,.5)',fontWeight:600}}>{st.label}</span>
 </div>
 ))}
 </div>
 </div>
 </div>

 {/* ── CALENDAR BODY ── */}
 <div style={{padding:'20px 28px'}}>

 {/* Room type filter */}
 <div style={{display:'flex',gap:8,marginBottom:16,flexWrap:'wrap'}}>
 {['All','Forest View Room','Lakeside Suite','Canopy Cottage','Jungle Tent'].map(t=>{
 const room = ROOMS.find(r=>r.type===t);
 return (
 <button key={t} onClick={()=>setFilterType(t)}
 style={{padding:'6px 14px',borderRadius:99,border:`1.5px solid ${filterType===t?(room?.color||C.accent):C.border2}`,background:filterType===t?(room?.bg||C.accentLight):'transparent',color:filterType===t?(room?.color||C.accent):C.text3,fontSize:12,fontWeight:600,cursor:'pointer'}}>
 {t==='All'?'All Rooms':t}
 </button>
 );
 })}
 </div>

 {/* Calendar */}
 <div style={{background:C.surface,borderRadius:16,overflow:'hidden',boxShadow:'0 4px 20px rgba(0,0,0,.08)',border:`1px solid ${C.border}`}}>
 {view==='weekly'
 ? <WeeklyCalendar startDate={weekStart} onCellClick={onCellClick}/>
 : <MonthlyCalendar year={calYear} month={calMonth} onCellClick={onCellClick}/>
 }
 </div>

 {/* Today's room status cards */}
 <div style={{marginTop:24}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:16,fontWeight:800,color:C.text,marginBottom:14}}>
 Today's Room Status
 </div>
 <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:12}}>
 {ROOMS.map(room=>{
 const status = getStatusForDate(room.id,fmt(today));
 const booking = getBookingForDate(room.id,fmt(today));
 const st = ROOM_STATUS[status]||ROOM_STATUS.free;
 return (
 <div key={room.id} onClick={()=>setPopup({room,booking,date:fmt(today)})}
 style={{background:C.surface,borderRadius:14,overflow:'hidden',cursor:'pointer',boxShadow:'0 2px 8px rgba(0,0,0,.06)',border:`1.5px solid ${st.border}`,transition:'all .15s'}}>
 {/* Color top */}
 <div style={{background:`linear-gradient(135deg,${room.color},${room.color}CC)`,padding:'12px 14px',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:18,fontWeight:800,color:'#fff'}}>Room {room.no}</div>
 <span style={{padding:'3px 10px',borderRadius:99,background:'rgba(255,255,255,.2)',color:'#fff',fontSize:10,fontWeight:600}}>{st.label}</span>
 </div>
 {/* Details */}
 <div style={{padding:'12px 14px',borderTop:`3px solid ${st.color}`}}>
 <div style={{fontSize:11,color:C.text3,marginBottom:4}}>{room.type} · {room.view} View · {room.capacity} guests</div>
 {booking
 ? <div>
 <div style={{fontSize:12,fontWeight:700,color:C.text,marginBottom:2}}>{booking.guest}</div>
 <div style={{fontSize:11,color:C.text3}}>{fmtDisplay(booking.checkIn)} → {fmtDisplay(booking.checkOut)}</div>
 </div>
 : <div style={{fontSize:12,fontWeight:600,color:C.accent}}>{inr(room.baseRate)}/night available</div>
 }
 </div>
 </div>
 );
 })}
 </div>
 </div>
 </div>
 </div>
 );
}


